import { sharedConfig as dataroomConfig } from './config/dataroom';
import finsightConfig from './config/finsight';
import condorConfig from './config/condor';
import usersConfig from './config/users';
import dmPortalConfig from './config/dmPortal';
import dealroadshowConfig from './config/dealroadshow';
import evercallConfig from './config/tenantEvercall';
import allocateConfig from './config/allocate';
import orderBookConfig from './config/orderBook';
import openmarketConfig from './config/openmarket';
import creditflowresearchConfig from './config/creditflowresearch';

const tenants = {
  ...dataroomConfig,
  finsight: finsightConfig,
  condor: condorConfig,
  users: usersConfig,
  dmPortal: dmPortalConfig,
  dealroadshow: dealroadshowConfig,
  tenantEvercall: evercallConfig,
  allocate: allocateConfig,
  orderBook: orderBookConfig,
  openmarket: openmarketConfig,
  creditflowresearch: creditflowresearchConfig,
} as Record<string, any>;

export default tenants;
